import React from 'react';
import Markdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import remarkMath from 'remark-math';

interface NotificationModalTextProps {
  text?: string | null;
}

export function CNotificationModalText(props: NotificationModalTextProps) {
  if (!props.text) {
    return null;
  }

  let formattedText = props.text;

  // Replace newlines with <br/>
  formattedText = formattedText
    .split(/(```[\s\S]*?```)/g)
    .map((part) => (part.startsWith('```') ? part : part.replaceAll(/\n/g, '<br/>')))
    .join('');

  // Code block formatting
  formattedText = formattedText.replace(/<br\/>[\n\s]*```/g, '\n```');
  formattedText = formattedText.replace(/[\n\s]*```<br\/>/, '\n```\n\n');

  return (
    <div className={'flex flex-col gap-4'}>
      <Markdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex, rehypeRaw]}
        components={{
          pre: ({ children }) => (
            <pre className={'whitespace-pre-wrap break-all text-sm p-4 border rounded-lg'}>{children}</pre>
          ),
          code: ({ children }) => {
            const lines = (children as string).split('\n');

            return (
              <code>
                {lines.slice(0, -1).map((line, ix) => (
                  <span key={ix} className={'flex gap-2'}>
                    <span className={'grow opacity-20 select-none'}>{String(ix).padStart(2, ' ')}</span>
                    <span
                      className={'w-[calc(100%-2rem)] shrink'}
                      style={{
                        paddingLeft: ix === 0 ? 0 : (line.match(/^ */) ?? [''])[0].length * 8
                      }}
                    >
                      {line.trim()}
                    </span>
                  </span>
                ))}
              </code>
            );
          }
        }}
      >
        {formattedText}
      </Markdown>
    </div>
  );
}
